/**
 * Sprint P.1.5 · Bloque K (CP4) · Placeholder sectorial para cards del marketplace.
 *
 * Cuando una organización no tiene `hero_image_url`, en lugar de mostrar un
 * genérico opacity-25 se elige un icono representativo del sector primario.
 * Los iconos vienen de `@phosphor-icons/react` (ya usado en el proyecto).
 *
 * REGLA · No usar imágenes que sugieran servicios que la organización NO
 * presta explícitamente. El icono es puramente decorativo · no engañoso.
 */
import {
  Drop,           // Lavado / detailing
  Wrench,         // Mecánica general
  PaintBrush,     // Chapa y pintura
  Sparkle,        // Cristalería / lunas
  Lightning,      // Electricidad
  Gauge,          // Diagnosis / ITV
  Tire,           // Neumáticos
  Motorcycle,     // Motocicletas
  Truck,          // Industriales
  Boat,           // Náutica
  Car,            // Concesionarios / genérico coche
  Storefront,     // Fallback genérico
} from "@phosphor-icons/react";

// Mapping id-de-sector → icono. Los ids provienen de la taxonomía
// `services/sectors.py` (backend) y los grupos `SECTOR_GROUPS_v1.2`.
const SECTOR_ICONS = {
  // Detailing & Estética
  detailing: Drop,
  wash: Drop,
  interior_cleaning: Drop,
  car_wash: Drop,
  polishing: Sparkle,

  // Mecánica
  general_mechanics: Wrench,
  fast_service: Wrench,
  mechanics: Wrench,
  electric: Lightning,
  electronics: Lightning,
  diagnostics: Gauge,
  pre_itv: Gauge,
  itv: Gauge,

  // Chapa y pintura
  body: PaintBrush,
  bodyshop: PaintBrush,
  paint: PaintBrush,

  // Cristalería
  glass: Sparkle,
  windows: Sparkle,

  // Neumáticos
  tires: Tire,
  wheels: Tire,
  alignment: Tire,

  // Movilidad especializada
  motorcycles: Motorcycle,
  motorcycle: Motorcycle,
  scooter: Motorcycle,
  industrial: Truck,
  trucks: Truck,
  agricultural: Truck,
  nautical: Boat,
  boats: Boat,

  // Compraventa / concesionarios
  dealership: Car,
  used_cars: Car,

  // Clásicos / restauración
  classics: Car,
  restoration: Car,
};

/**
 * Icono representativo del sector primario de una org.
 * @param {Object} org
 * @returns {React.ComponentType} Componente icono Phosphor
 */
export function sectorPlaceholderIcon(org) {
  const sectors = Array.isArray(org?.sectors) ? org.sectors : [];
  for (const s of sectors) {
    // s puede ser id string ("wash") o objeto {id, label_es}
    const key = typeof s === "string" ? s.toLowerCase() : (s?.id || "").toLowerCase();
    if (!key) continue;
    // Exact match
    if (SECTOR_ICONS[key]) return SECTOR_ICONS[key];
    // Prefix match sobre grupos conocidos
    for (const k of Object.keys(SECTOR_ICONS)) {
      if (key.includes(k) || k.includes(key)) return SECTOR_ICONS[k];
    }
  }
  return Storefront;
}
